import React from "react";

export const ActivePartnerContext = React.createContext(undefined);
